import React from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import '@mantine/core/styles.css';
import './styles.css'
import './index.css'
import App from './App'

const container = document.getElementById('root');
const root = createRoot(container);
console.log('TIP: Toggle screensaver with window.toggleScreensaver()')

root.render(
  <React.StrictMode>
    <MantineProvider>
      <App />
    </MantineProvider>
  </React.StrictMode>
);
